export function resolveHeaderMessage(messages = {}, path = '', fallback = '') {
  const value = String(path)
    .split('.')
    .filter(Boolean)
    .reduce((accumulator, segment) => {
      if (!accumulator || typeof accumulator !== 'object') {
        return undefined;
      }

      return accumulator[segment];
    }, messages);

  return typeof value === 'string' && value.trim() ? value : fallback;
}
